import React, { useState } from "react";

import { ShareIcon } from "../../common/icons";
import ShareModal from "../../sections/modal-button/ShareModal";

interface ShareButtonProps {
  shareUrl: string;
}

const ShareButton: React.FC<ShareButtonProps> = ({ shareUrl }) => {
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);

  return (
    <div className="relative group">
      <button
        className="hover:scale-110 transition-transform w-10 h-10 rounded-full p-2 border border-primary"
        onClick={() => setIsShareModalOpen(true)}
      >
        <ShareIcon />
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block pointer-events-none">
          <div className="bg-gray-800 text-white px-2 py-1 rounded text-sm whitespace-nowrap">
            Share
          </div>
        </div>
      </button>

      <ShareModal
        open={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
        shareUrl={shareUrl}
      />
    </div>
  );
};

export default ShareButton;
